import { Grid } from '@enterprise-ui/canvas-ui-react';
import React__default from 'react';
import { useTable } from '../utils/hooks.js';
import PageSize from './PageSize.js';
import PaginationNavigation from './PaginationNavigation.js';
import ShowItems from './ShowItems.js';

var TablePagination = function TablePagination(_ref) {
  var dataTestId = _ref.dataTestId;
  var _useTable = useTable(),
    _useTable$state = _useTable.state,
    isServer = _useTable$state.isServer,
    pagination = _useTable$state.pagination;
  var hidePagination = pagination.hidePagination,
    pageSize = pagination.pageSize,
    pageSizeOptions = pagination.pageSizeOptions;
  if (hidePagination) {
    return null;
  }
  if (pageSizeOptions && !pageSizeOptions.includes(pageSize) && isServer) {
    console.error("Hey Canvas User! Table pagination requires pageSize ".concat(pageSize, " to be one of the pageSizeOptions ").concat(pageSizeOptions));
  }
  var testId = dataTestId ? "".concat(dataTestId, "_tablePagination") : null;
  return /*#__PURE__*/React__default.createElement(Grid.Container, {
    align: "center",
    className: "C-TableAdvanced__pagination hc-mt-expanded hc-ph-normal",
    justify: "space-between",
    "data-testid": testId,
    spacing: "none"
  }, /*#__PURE__*/React__default.createElement(ShowItems, {
    dataTestId: testId
  }), /*#__PURE__*/React__default.createElement(PaginationNavigation, {
    dataTestId: testId
  }), /*#__PURE__*/React__default.createElement(PageSize, {
    dataTestId: testId
  }));
};

export { TablePagination, TablePagination as default };
